import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class ButtonComponent implements OnInit {

  btnStyle = {
    marginTop: '',
    marginBottom: ''
  };

  @Input('text') text;
  @Input('position') position;
  @Output() parentSendEvt = new EventEmitter();

  click(e) {
    let circle = document.createElement('div');
    let target = this.el.nativeElement.firstElementChild;

    if(target.firstElementChild) target.firstElementChild.remove();

    let d = Math.max(target.clientWidth, target.clientHeight);

    circle.style.width = circle.style.height = d + 'px';
    circle.style.left = e.clientX - target.offsetLeft - d / 2 + 'px';
    circle.style.top = e.clientY - target.offsetTop - d / 2 + 'px';
    
    circle.classList.add('ripple');

    target.appendChild(circle);

    this.parentSendEvt.emit();
  }

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.position === 'bottom' ? this.btnStyle = {...this.btnStyle, marginTop: '15px'} : this.btnStyle = {...this.btnStyle, marginBottom: '15px'};
  }

}
